export function navigateTo(lat, lon) {
  let url = `https://www.google.com/maps/dir/?api=1&parameters&destination=${lat},${lon}`;
  window.open(url);
}

export function showOnGoogleMaps(lat, lon) {
  let url = `https://www.google.com/maps/place/${lat},${lon}`;
  window.open(url);
}
